import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { apiErr } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async () => {
    if (!email) return toast.error("Enter your email");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) { toast.error(apiErr(e)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-cream flex flex-col">
      <div className="px-5 py-4">
        <Button variant="ghost" size="sm" className="rounded-full" data-testid="forgot-back-btn" onClick={() => navigate("/auth")}>
          <ArrowLeft className="h-4 w-4 mr-1" /> Back to sign in
        </Button>
      </div>
      <div className="flex-1 flex items-center justify-center px-5 pb-10">
        <div className="w-full max-w-md bg-white rounded-3xl p-7 shadow-[0_8px_32px_rgba(44,44,62,0.08)] animate-fade-up">
          {sent ? (
            <div className="text-center space-y-3">
              <div className="h-12 w-12 rounded-2xl accent-bg mx-auto flex items-center justify-center text-white"><MailCheck className="h-6 w-6" /></div>
              <h1 className="font-heading font-bold text-2xl text-[var(--brand-navy)]">Check your email</h1>
              <p className="text-sm text-muted-foreground">If an account exists for <strong>{email}</strong>, we've sent a link to reset your password. The link expires in 1 hour.</p>
              <Button data-testid="forgot-done-btn" onClick={() => navigate("/auth")} className="w-full mt-2 rounded-full accent-bg text-white h-11 hover:opacity-90">Back to sign in</Button>
            </div>
          ) : (
            <>
              <h1 className="font-heading font-bold text-2xl text-[var(--brand-navy)] mb-1">Reset your password</h1>
              <p className="text-sm text-muted-foreground mb-6">Enter your email and we'll send you a reset link.</p>
              <Label className="text-sm text-[#2C2C3E]">Email</Label>
              <Input data-testid="forgot-email" type="email" className="mt-1.5 rounded-xl h-11" value={email} onChange={(e) => setEmail(e.target.value)} />
              <Button data-testid="forgot-submit-btn" disabled={loading} onClick={submit} className="w-full mt-6 rounded-full accent-bg text-white h-12 hover:opacity-90">
                {loading ? "Sending…" : "Send reset link"}
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
